<template>
  <DTrackingLink
    :class="shouldResetStyle ? null : [ `button-${type}`, 'd-signup-button', 'button' ]"
    :event-name="eventName"
    :force-new-tracking-chain="forceNewTrackingChain"
    :text="text"
    :tracking-extra="trackingExtra"
    :tracking-modals="trackingModals"
    :url="url"
  >
    <img
      v-if="shouldResetStyle && type !== 'email'"
      :alt="type | duiCapitalize"
      :src="isGoogleImage ? googleImage : facebookImage"
      :width="imageDimensions.width"
      :height="imageDimensions.height"
    >

    <span
      v-else
      class="button-content"
      :class="{
        'reverse': isIconFirst
      }"
    >
      <span v-if="!!text">{{ text }}</span>

      <DuiIconFacebook
        v-if="type === 'facebook'"
        class="icon-white icon-lg"
      />
      <DuiIconGoogle
        v-else-if="type === 'google'"
        class="icon-lg"
      />

      <slot />
    </span>
  </DTrackingLink>
</template>

<script>
import DTrackingLink from '@d-shared/components/d-tracking-link/d-tracking-link.vue';

import FACEBOOK_SIGN_IN_IMG from '@d-assets/facebook-sign-in.svg';
import GOOGLE_SIGN_IN_IMG from '@d-assets/google-sign-in.svg';
import { IMAGE_DIMENSIONS } from '@d-shared/config';

const TYPE_TO_EVENT_NAME = {
  'email': 'sign-up-request',
  'google': 'social-sign-in-request',
  'facebook': 'social-sign-in-request',
};

export default {
  components: {
    DTrackingLink,
  },
  props: {
    forceNewTrackingChain: {
      type: Boolean,
      default: false,
    },
    isIconFirst: {
      type: Boolean,
      default: false,
    },
    shouldResetStyle: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    trackingExtra: {
      type: Object,
      default: null,
    },
    trackingModals: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      required: true,
      validator: function (value) {
        return [ 'facebook', 'google', 'email' ].indexOf(value) !== -1;
      },
    },
    url: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    facebookImage: FACEBOOK_SIGN_IN_IMG,
    googleImage: GOOGLE_SIGN_IN_IMG,
  }),
  computed: {
    eventName: function() {
      return TYPE_TO_EVENT_NAME[this.type];
    },
    isGoogleImage: function() {
      return this.type === 'google';
    },
    imageDimensions: function() {
      return this.isGoogleImage ? IMAGE_DIMENSIONS.googleSignIn : IMAGE_DIMENSIONS.facebookSignIn;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-signup-button {
  .button-content {
    display: inline-flex;
    align-items: center;
    justify-content: center;

    &.reverse {
      flex-direction: row-reverse;

      .dui-icon {
        margin: 0 $_1em 0 0;
      }
    }

    .dui-icon {
      margin: 0 0 0 $_1em;
    }
  }
}
</style>
